export default __webpack_public_path__ + "static/media/smile12.5052dadb.jpg";